import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";import Checkbox from "../../Checkbox";
import React, { useEffect, useState } from 'react';

import { createStyles } from "./styles";

var FilterCheckboxOption = function FilterCheckboxOption(_ref)








{var _ref$id = _ref.id,id = _ref$id === void 0 ? '' : _ref$id,label = _ref.label,onFilterChange = _ref.onFilterChange,onGroupCheckboxChange = _ref.onGroupCheckboxChange,attributeType = _ref.attributeType,displayName = _ref.displayName,shouldBeReset = _ref.shouldBeReset,defaultFilters = _ref.defaultFilters;
  // Change visually value in checkbox
  var getCheckboxValue = function getCheckboxValue() {
    if (attributeType === 'tag') {var _context;
      return defaultFilters ? _includesInstanceProperty(_context = defaultFilters.tag).call(_context, id) : false;
    }
    if (attributeType === 'valueCheckbox' && displayName) {var _context2;
      return !!(defaultFilters && defaultFilters[displayName] ?
      _includesInstanceProperty(_context2 = defaultFilters[displayName]).call(_context2, label) :
      false);
    }
    // Boolean checkbox
    return !!(defaultFilters ? defaultFilters[label] : false);
  };

  var _useState = useState(getCheckboxValue()),_useState2 = _slicedToArray(_useState, 2),isChecked = _useState2[0],setIsChecked = _useState2[1];
  var classes = createStyles();

  useEffect(function () {
    if (shouldBeReset) setIsChecked(false); // reset value in state
  }, [shouldBeReset]);

  var onCheckboxChange = function onCheckboxChange() {
    setIsChecked(!isChecked);
    if (attributeType === 'valueCheckbox' && displayName && onGroupCheckboxChange) {
      onGroupCheckboxChange(displayName, _defineProperty({}, label, !isChecked));
      return;
    }

    if (attributeType === 'tag' && displayName && onGroupCheckboxChange) {
      onGroupCheckboxChange(displayName, _defineProperty({}, id, !isChecked));
      return;
    }

    if (onFilterChange) onFilterChange(label, !isChecked);
  };

  return /*#__PURE__*/(
    React.createElement("div", { className: classes.checkbox }, /*#__PURE__*/
    React.createElement(Checkbox, { label: label, name: label, onChange: onCheckboxChange, checked: isChecked })));


};

export default FilterCheckboxOption;
//# sourceMappingURL=index.js.map